export { default } from './DuoAuthCallback';
